export enum PaymentModeOptions {
  NEW,
  EDIT,
  DUPLICATE
}